import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import AppLink from "./AppLink";

import { blue } from "@mui/material/colors";
import { titleCase } from "../helpers";
import Button from "@mui/material/Button";
import { Contractor } from "../models";
import RelicAvatar from "./RelicAvatar";
import { ROUTES } from "../history";

const ContractorView: React.FC<{
  contractor: Contractor;
  onClick?: () => void;
  show?: boolean;
}> = ({ contractor, onClick, show = true }) => {
  return (
    <Box
      sx={{
        minWidth: "250px",
      }}
    >
      <Box display="flex" sx={{ mb: 2 }}>
        <RelicAvatar
          size={60}
          display
          user={contractor}
          avatarBgColor={blue[500]}
        />

        <div style={{ paddingLeft: "1em" }}>
          <Typography fontWeight={"bold"}>
            {titleCase(contractor.Name)}
          </Typography>
          <Typography variant="subtitle1" color="#6B779A" sx={{ mb: 1 }}>
            {contractor.Email}
          </Typography>
        {  !!onClick && (<Button
            variant="outlined"
            color={contractor.isVerified ? "error" : "success"}
            sx={{
              mr: 1,
            }}
            onClick={onClick}
          >
            {contractor.isVerified ? "Deactivate" : "Activate"}
          </Button>)}
          {show && (
            <AppLink
              to={ROUTES.ADMIN_BASE + "/contractors/view/" + contractor.id}
            >
              View
            </AppLink>
          )}
        </div>
      </Box>

      <div
        style={{
          padding: "1em",
          borderRadius: "24px",
          border: "1px solid rgba(107, 119, 154, 0.1)",
        }}
      >
        <Typography component="h6" variant="h6" fontWeight={"bold"}>
          User Info
        </Typography>
        <Grid
          container
          spacing={1}
          style={{
            marginBottom: "12px",
          }}
        >
          <Grid item xs={6}>
            <div className="name-item">
              <Typography variant="subtitle1">Age</Typography>
              <Typography fontWeight={"bold"}>25 years</Typography>
            </div>
          </Grid>

          <Grid item xs={6}>
            <div className="name-item">
              <Typography variant="subtitle1">Discipline</Typography>
              <Typography fontWeight={"bold"}>
                {contractor.Specialization}
              </Typography>
            </div>
          </Grid>
        </Grid>

        <div
          style={{
            padding: "1em",
            borderRadius: "24px",
            border: "1px solid rgba(107, 119, 154, 0.1)",
            backgroundColor: "#F8F8FA",
          }}
        >
          <Typography fontWeight={"bold"}>Services</Typography>

        { contractor.Services && (
              <div>
     
              <List aria-labelledby="basic-list-demo">
                {contractor.Services.list.map((v, index) => (
                    <ListItem key={contractor.userId  + '-' + index}>
                        {v}
                    </ListItem>
                ))}
              </List>
            </div>
        )}
        </div>
      </div>
    </Box>
  );
};

export default ContractorView;
